import { LoaderCircleIcon, RotateCwIcon } from 'lucide-react'

import { Button, type ButtonProps } from '@/components/ui/button'
import useTranslator from '@/hooks/translation'

interface FeedbackRetryButtonProps {
  variant: ButtonProps['variant']
  onRetry: VoidFunction
  isRetrying?: boolean
}

export function FeedbackRetryButton({
  variant,
  onRetry,
  isRetrying = false,
}: FeedbackRetryButtonProps) {
  const { getTranslation } = useTranslator()

  return (
    <>
      <Button
        type="button"
        variant={variant}
        aria-disabled={isRetrying}
        aria-busy={isRetrying}
        onClick={isRetrying ? undefined : onRetry}
        className="aria-disabled:pointer-events-none aria-disabled:opacity-50"
      >
        {isRetrying ? (
          <LoaderCircleIcon
            className="animate-spin [&>*]:stroke-[2]"
            aria-hidden
          />
        ) : (
          <RotateCwIcon className="[&>*]:stroke-[2]" aria-hidden />
        )}
        {getTranslation('common.retry')}
      </Button>
      <span role="status" className="sr-only">
        {isRetrying ? getTranslation('common.loading') : null}
      </span>
    </>
  )
}
